import api from '@/store/api.js'

const sendResizeJobToBackend = async ({file, width}) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('width', width);
  return api.resizeImage(`/image/resize`, formData)
}

export const resizeImage = async (file, config) => {
  const res = await sendResizeJobToBackend({file, width:config.width})
  const blob = new Blob([res.data], { type: 'image/jpeg' });
  return new File([blob], file.name, { lastModified: new Date().getTime(), type:  'image/jpeg' } )
}

export const dataUrlToFile = async (dataUrl, fileName) => {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: 'image/png' });
}

export const imageResizeConfigs = [
  {  width: 170, folder: '170' },
  {  width: 220, folder: '220' },
  {  width: 270, folder: '270' },
  {  width: 570, folder: '570' },
  {  width: 870, folder: '870' },
  {  width: 1170, folder: '1170' },
  {  width: 1920, folder: '1920' },
]
